import axios from "axios";
import { handleServerError } from "kinnect-helpers";

export default {
	install( Vue ) {
		axios.defaults.baseURL = process.env.VUE_APP_API_URL;
		axios.defaults.withCredentials = true;

		axios.interceptors.response.use(
			response => response,
			error => handleServerError( error )
		);

		Vue.axios = axios;
		Vue.prototype.axios = axios;
		Vue.prototype.$http = axios;
	}
};
